<template>
  <div>
    <Div class="border">
      <h5>
        {{
          "say_client_reigster_in_intend_syste"
            | setText(
              " Попросите клиента зарегистрироваться в системе InTend под номером"
            )
        }}
        {{ order.client.phone }}
      </h5>
      <h3>https://reg.intend.uz</h3>
      <qrcode-vue
        :value="`https://reg.intend.uz`"
        :size="220"
        level="H"
      ></qrcode-vue>
    </Div>
    <h5>
      {{
        "after_register_intend_app"
          | setText('После регистрации нажмите "Начать сначала"')
      }}}
    </h5>
    <div class="install-control">
      <button @click="next" class="btn btn-success">
        {{ "begin" | setText("Начать сначала") }}
      </button>
    </div>
  </div>
</template>
<script>
import QrcodeVue from "qrcode.vue";
import { logger } from "../../../plugins/functions";
export default {
  components: {
    QrcodeVue,
  },
  props: {
    partner: {
      default: function () {
        return {};
      },
    },
    order: {
      default: function () {
        return {};
      },
    },
    index: {
      default: 0,
    },
  },
  name: "filter",
  async created() {
    logger(this.$http, {
      name: "Проверка пользователя в #INTEND",
      description: "Клиента нет в системе #INTEND. Процесс регистрации...",
      model_type: "order",
      model_id: this.order.id,
    });
  },
  methods: {
    next() {
      this.$emit("next", 0);
    },
    prev() {
      this.$emit("next", this.index - 1);
    },
  },
  data() {
    return {};
  },
};
</script>
<style lang="scss">
</style>
